import { useCallback, useEffect, useRef, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Button, Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import styled from "@emotion/styled";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import calendericon from "../assets/auth/calendericon.svg";
import { BiList, MaterialSymbols } from "../utils/gridbuttons/gridbutton";
import CloseIcon from "@mui/icons-material/Close";
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import { customObjectToDateString } from "../dateutils/date";
import api from "../api/api";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentDate, setTab } from "../reduxtoolkit/filterslice";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { el } from "date-fns/locale";
import ToastMessage from "../utils/mui/righttoptoast";
import { actionDropDownCalenderIcon, filterIcon } from "./modals/svgs";
import { flag } from "./landingsvgs";
import FlagModal from "./modals/flagmodal";
import HomeToastMessage from "../utils/mui/Hometoptoast";
import { leftarrow, rightarrow } from "../colorcoding/svg/iconsvg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import kicon from '../assets/landingscreen/kicon.svg'
const STATUS_MAP = { "Checked-in": "chk", Morning: "mng", Afternoon: "afr" };

const NavigationMenu = ({
  isCardView,
  selectedFilterName,
  setFiltermodal,
  setSelectedFilterName,
  dbscount,
  setStartDate,
  setIsCardView,
  dob,
  fetchDashboardData,
  setDashboardfilter,
  appliedFilter,
  setAppliedFilter,
  searchedUser,
  setSearchedUser,
  clearSearchUser,
  searchTerm,
  setSearchTerm
}) => {
  const practiseid = window.getPracticeId();
 ;
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.filter.tab);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const username = localStorage.getItem("user");
  const today = new Date();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionData, setSuggestions] = useState([]);
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  };
  const userConfig = useSelector((state) => state.userconfig);
  const formatDate = today.toLocaleDateString("en-US", options);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const calendarRef = useRef(null);
  const calendarButtonRef = useRef(null);
  const navigate = useNavigate(); // Initialize the navigate function
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const suggestionsRef = useRef(null);
  const currentDate = useSelector((state) => state.filter.currentDate);
  const [isFlagOpen, setIsFlagOpen] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [issearching, setIsSearching] = useState(false);
  const [kioskStatus, setKioskStatus] = useState([]);
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);
    fetchSearchResults(query); // Fetch results based on input
    if (!query) {
      setShowSuggestions(false);
      setSuggestions([]);
    } else {
      setShowSuggestions(true); // Show suggestions if there's input
    }
  };

  const UI_DATE_FMT = "MM-DD-YYYY";
  const formatDateForUI = (d) =>
    d ? dayjs(d).format(UI_DATE_FMT) : dayjs().format(UI_DATE_FMT);

  useEffect(() => {
    const dateToUse = currentDate
      ? dayjs(currentDate) // Convert string to Dayjs
      : dayjs(); // Otherwise, use today

    setSelectedDate(dateToUse);
  }, [currentDate]);

  const isToday = selectedDate.isSame(dayjs(), "day");

  const tabMapping = [
    { label: "Active", key: "active" },
    { label: "No-Show", key: "noshow" },
    { label: "Telehealth", key: "tele" },
    { label: "Checked Out", key: "checkedout" },
  ];
    const handlePrevDate = () => {
  const prevDate = selectedDate.subtract(1, "day");
  handleDateChange(prevDate, true);
};

const handleNextDate = () => {
  const nextDate = selectedDate.add(1, "day");
  handleDateChange(nextDate, true);
};
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestions(false); // Hide suggestions
      }
    };

    document.addEventListener("mousedown", handleClickOutside); // Add event listener

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup
    };
  }, []);
const handleSearchKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();

    if (suggestionData?.length > 0) {
      handleSuggestionClick(suggestionData[0]); // open first suggestion
    }
  }
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        calendarButtonRef.current &&
        !calendarButtonRef.current.contains(event.target)
      ) {
        setIsCalendarOpen(false); // Hide calendar
      }
    };

    document.addEventListener("mousedown", handleClickOutside); // Add event listener

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup
    };
  }, []);

  const fetchSearchResults = useCallback(
    debounce(async (query) => {
      if (!query) {
        setSuggestions([]);
        return;
      }
      try {
        setIsSearching(true);
        const response = await api.post(
          `/v1/${practiseid}/autocomplete/dssearch`,
          {
            searchtxt: query,
          }
        );

        if (response.status === 200 && response.data) {
          setSuggestions(response.data || []);
          setShowSuggestions(true);
        }
      } catch (error) {
        console.error("Error fetching search results:", error);
        setShowSuggestions(false);
        setSuggestions([]);
      } finally {
        setIsSearching(false);
      }
    }, 500),
    [] // Add dependencies
  );
  const handleDateChange = (date, preserveFilters = true) => {
    setSelectedDate(date);
    const dateString = date && customObjectToDateString(date);
    dispatch(setCurrentDate(dateString));
    // setStartDate(date&&customObjectToDateString(date))
    setIsCalendarOpen(false);

    // Clear searched user when date changes
    if (searchedUser) {
      clearSearchUser?.();
      setSearchTerm("");
      setShowSuggestions(false);
      setSuggestions([]);
      dob.current = "";
    }

    // Only preserve existing filters when date changes from calendar, not from chip removal
    if (preserveFilters) {
      fetchDashboardData({
        searchflag: "",
        filter: appliedFilter || "",
        labels: selectedFilterName || {},
        appointmentdate: dateString,
      });
    } else {
      // When removing date chip, reset to today with no filters
      fetchDashboardData({
        searchflag: "",
        filter: "",
        labels: {},
        appointmentdate: dateString,
      });
    }
  };
  const handleSuggestionClick = (item) => {
    setSearchTerm(item.patientinfo); // Clear search input
    setShowSuggestions(false); // Hide suggestions
    setSuggestions([]); // Clear suggestions list

    // Set the searched user for chip display
    setSearchedUser({
      patientid: item.patientid,
      patientinfo: item.patientinfo,
      lastname: item.lastname,
    });

    if (item?.dob) {
      dob.current = item?.dob;
    } else {
      dob.current = "";
    }
    fetchDashboardData({ searchflag: item.patientid });

    // refresh(`${item.patientid}`); // Call refresh with patient ID
  };

  const syncapppointments = async () => {
    try {
      setIsSyncing(true);
     let response ;
      if(practiseid==1111){
       response = await api.post(`/v1/${practiseid}/appointments/refresh/external`,
        {
          apikey: "bmkxeyjfqpwapjqedzj",
          "startdate": dayjs().format('YYYY-MM-DD'),
        }
      );
      }else{
        response = await api.post(
        `/v1/${practiseid}/appointments/refresh/apt`,
        {
          apikey: "127d196f773179685bb945abb7a8f781",
          department_id: userConfig?.config?.departmentid,
        }
      );
      }
   
      if (response.status === 200) {
        // setToastMessage(
        //   `Appointments synced successfully${
        //     response?.count != null
        //       ? `. ${response.count} new appointment${
        //           response.count === 1 ? "" : "s"
        //         } found.`
        //       : ""
        //   }`
        // );
        setToastMessage(
          <div className="flex flex-col text-left items-center">
            Sync Complete.
            <br />
            {response?.count != null &&
              `${response.count} New Appointment${
                response.count === 1 ? "" : "s"
              } Found.`}
          </div>
        );

        setToastSeverity("success");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSyncing(false);
      fetchDashboardData({ searchflag: "" });
    }
  };

  const fetchKioskStatus = useCallback(async () => {
    try {
      const res = await api.get(`/v1/${practiseid}/kiosk/status`);
      if (res.status === 200) {
        console.log("Kiosk Status:", res.data);
        setKioskStatus(res.data);      
      }else{
        setKioskStatus([]); 
        console.error("Kiosk Status No data found:", res.status);
      }
    } catch (e) {
      setKioskStatus([]);
      console.error("Error fetching Kiosk Status:", e);
    }
  }, [practiseid]);

  useEffect(() => {
    fetchKioskStatus();
    const interval = setInterval(() => {
      fetchKioskStatus();
    }, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setSearchTerm("");
    setShowSuggestions(false); // Hide suggestions
    setSuggestions([]);
    clearSearchUser?.(); // Clear searched user
    dispatch(setTab(null));
    navigate("/landing", { state: { item: null }, replace: true });
    syncapppointments();
  };

  const chips = (() => {
    const labels = selectedFilterName || {};
    const arr = [];
 

    // Add searched user chip if exists
    if (searchedUser) {
      arr.push({
        group: "search",
        key: "search",
        text: searchedUser.patientinfo,
      });
    }

    const dateToShow =
      labels.date ||
      (selectedDate && !dayjs(selectedDate).isSame(dayjs(), "day")
        ? formatDateForUI(selectedDate)
        : null);

    if (dateToShow) {
      arr.push({
        group: "date",
        key: "date",
        text: dateToShow,
      });
    }

    // if (labels.date)
    //   arr.push({ group: "date", key: "date", text: labels.date });

    (labels.status || []).forEach((s) =>
      arr.push({ group: "status", key: STATUS_MAP[s], text: s })
    );

    (labels.providers || []).forEach((p) =>
      arr.push({ group: "providers", key: String(p.id), text: p.name })
    );

    if (labels.orderStatus)
      arr.push({
        group: "orderStatus",
        key: "orderStatus",
        text: `Order: ${labels.orderStatus}`,
      });

    (labels.visitStatus || []).forEach((v) =>
      arr.push({ group: "visitStatus", key: String(v.id), text: v.name })
    );

    if (labels.category)
      arr.push({
        group: "category",
        key: "category",
        text: `Category: ${labels.category}`,
      });

    if (labels.rpm)
      arr.push({ group: "rpm", key: "rpm", text: `RPM: ${labels.rpm}` });

    if (labels.raisedIssue)
      arr.push({
        group: "raisedIssue",
        key: "raisedIssue",
        text: labels.raisedIssue,
      });

    if (labels.levelOfVisit)
      arr.push({
        group: "levelOfVisit",
        key: "levelOfVisit",
        text: `LOV: ${labels.levelOfVisit}`,
      });

    if (labels.acoConditions)
      arr.push({
        group: "acoConditions",
        key: "acoConditions",
        text: labels.acoConditions,
      });

    return arr;
  })();

  // remove a single chip -> update filter + labels -> refetch
  const handleRemoveChip = (chip) => {
    const nextFilter = { ...(appliedFilter || {}) };
    const nextLabels = JSON.parse(JSON.stringify(selectedFilterName || {}));

    switch (chip.group) {
      case "search":
        // Clear searched user and search term
        clearSearchUser?.();
        setSearchTerm("");
        setShowSuggestions(false);
        setSuggestions([]);
        dob.current = "";
        break;

      case "date":
        delete nextFilter.filterdate;
        delete nextLabels.date;
        // Reset to today's date but preserve other filters
        const today = dayjs();
        setSelectedDate(today);
        dispatch(setCurrentDate(today.format("YYYY-MM-DD")));
        // Fetch data with today's date but preserve other filters
        fetchDashboardData({
          searchflag: searchedUser ? searchedUser.patientid : "",
          filter: nextFilter,
          labels: nextLabels,
          appointmentdate: today.format("YYYY-MM-DD"),
        });
        return;

      case "status":
        nextFilter.status = (nextFilter.status || []).filter(
          (c) => c !== chip.key
        );
        if (!nextFilter.status?.length) delete nextFilter.status;
        nextLabels.status = (nextLabels.status || []).filter(
          (s) => STATUS_MAP[s] !== chip.key
        );
        if (!nextLabels.status?.length) delete nextLabels.status;
        break;

      case "providers":
        nextFilter.provider = (nextFilter.provider || []).filter(
          (id) => String(id) !== String(chip.key)
        );
        if (!nextFilter.provider?.length) delete nextFilter.provider;
        nextLabels.providers = (nextLabels.providers || []).filter(
          (p) => String(p.id) !== String(chip.key)
        );
        if (!nextLabels.providers?.length) delete nextLabels.providers;
        break;

      case "orderStatus":
        delete nextFilter.statusNotes;
        delete nextLabels.orderStatus;
        break;

      case "visitStatus":
        nextFilter.visit = (nextFilter.visit || []).filter(
          (id) => String(id) !== String(chip.key)
        );
        if (!nextFilter.visit?.length) delete nextFilter.visit;
        nextLabels.visitStatus = (nextLabels.visitStatus || []).filter(
          (v) => String(v.id) !== String(chip.key)
        );
        if (!nextLabels.visitStatus?.length) delete nextLabels.visitStatus;
        break;

      case "category":
        delete nextFilter.afcategory;
        delete nextLabels.category;
        break;

      case "rpm":
        delete nextFilter.rpmstatus;
        delete nextLabels.rpm;
        break;

      case "raisedIssue":
        delete nextFilter.issueflagstatus;
        delete nextLabels.raisedIssue;
        break;

      case "levelOfVisit":
        delete nextFilter.lovstatus;
        delete nextLabels.levelOfVisit;
        break;

      case "acoConditions":
        delete nextFilter.acostatus;
        delete nextLabels.acoConditions;
        break;

      default:
        break;
    }

    setAppliedFilter?.(nextFilter);
    setSelectedFilterName?.(nextLabels);
    fetchDashboardData({
      searchflag: "",
      filter: nextFilter,
      labels: nextLabels,
    });
  };

  const handleClearAll = () => {
    const today = dayjs();
    setSelectedDate(today);
    dispatch(setCurrentDate(today.format("YYYY-MM-DD")));
    setAppliedFilter?.();
    setSelectedFilterName?.({});
    // Clear searched user
    clearSearchUser?.();
    setSearchTerm("");
    setShowSuggestions(false);
    setSuggestions([]);
    dob.current = "";
    // Refresh the appointment data with the new current date
    fetchDashboardData({
      searchflag: "",
      filter: "",
      labels: {},
      appointmentdate: today.format("YYYY-MM-DD"),
    });
  };

  return (
    <div className="w-full">
      {/* First Row: Greeting, Date, and Search Bar */}
      <div className="flex flex-col space-y-4">
        <div className="flex justify-between items-center">


 <div>
            <div className="font-bold text-neutral-700 text-start text-xl whitespace-nowrap">
              Hello, {username}
            </div>
            <div className="flex items-center  space-x-2 text-neutral-700 lg:text-md">
              <CalendarMonthIcon />
              <span>{formatDate}</span>
            </div>
          </div>
          

   <div className="flex-1 mr-[10%] min-w-[250px] max-w-[550px] relative">
              <div className="relative flex items-center bg-white border shadow-md sm:min-w-[550px] border-gray-300 rounded-full py-2 pl-2 pr-4">
                {/* Search Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  className="flex-shrink-0"
                >
                  <g opacity="0.5">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.6939 12.535C12.4237 11.3748 13.6962 8.22136 12.5361 5.49152C11.3759 2.76168 8.22245 1.4892 5.49261 2.64936C2.76278 3.80951 1.49029 6.96297 2.65045 9.69281C3.8106 12.4226 6.96406 13.6951 9.6939 12.535Z"
                      stroke="black"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.3906 11.3896L15.556 15.5556"
                      stroke="black"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>

                {/* Search Input */}
                <input
                  type="text"
                  placeholder="Search"
                  className="w-full text-sm bg-transparent border-none outline-none pl-2 text-neutral-700"
                  value={searchTerm}
                  onChange={handleSearch}
                    onKeyDown={handleSearchKeyDown} 
                />

                {/* Right-side loader or clear button */}
                <div className="absolute right-4 flex items-center">
                  {issearching ? (
                    // Loader
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                      ></path>
                    </svg>
                  ) : searchTerm ? (
                    <></>
                  ) : null}
                </div>
              </div>

              {showSuggestions && suggestionData.length > 0 && (
                <div
                  ref={suggestionsRef}
                  className="absolute z-10 w-full bg-white border border-neutral-300 text-start  rounded mt-1 max-h-60 overflow-y-auto"
                >
                  {suggestionData.map((item) => (
                  <div
  key={item.patientid}
  className="p-2 cursor-pointer font-semibold text-[#989898] flex items-center justify-between text-sm transition-colors duration-200 hover:bg-neutral-100 hover:text-blue-600"
  onClick={() => handleSuggestionClick(item)}
>
  {item.patientinfo} {item.lastname}

  {item.dob && (
    <span className="ml-2 opacity-80">
      {dayjs(item.dob).format("MM-DD-YYYY")}
    </span>
  )}
</div>

                  ))}


                </div>
              )}
            </div>


          <div className="flex flex-wrap gap-2">
            {kioskStatus && kioskStatus.length > 0 ? (
              kioskStatus.map((v, index) => (
                <span
                  key={index}
                  className="mx-1 flex flex-col items-center  rounded-sm"
                  title={v.serial_number}
                >
                  {/* <DesktopMacIcon className={`${v.bgcolor} text-success`} /> */}
<img src={kicon} alt="kiosk" />
             <div className="text-[11px] font-medium tracking-wide mt-[2px]">
        {v.showStatus}
      </div>
                </span>
              ))
            ) : (
              ""
            )}
          </div>

         
          <div className="flex items-center space-x-4">
            <div
              onClick={() => {
                if (isSyncing) return;
                handleRefresh();
              }}
              className={`cursor-pointer ${isSyncing ? "sync-anim" : ""}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 33 33"
                fill="none"
              >
                <path
                  d="M24.27 10.5188C23.1072 9.00832 21.5295 7.86955 19.7297 7.24175C17.93 6.61394 15.9862 6.52434 14.1363 6.98389C12.2864 7.44345 10.6106 8.43224 9.31386 9.82928C8.01711 11.2263 7.15568 12.9711 6.83496 14.85M24.7512 5.5V11H19.2512M8.72971 22.4813C9.8921 23.9923 11.4698 25.1316 13.2697 25.7598C15.0697 26.3879 17.0137 26.4777 18.8638 26.0181C20.714 25.5585 22.39 24.5694 23.6867 23.172C24.9834 21.7745 25.8445 20.0293 26.1647 18.15M8.24984 27.5V22H13.7498"
                  stroke="#979797"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

         
          </div>
        </div>

        {/* Second Row: Tabs and Calendar */}
        <div
          className={`flex flex-col gap-4 sm:flex-row sm:gap-0 ${
            dayjs(selectedDate).isSame(dayjs(), "day")
              ? "justify-around"
              : "justify-end"
          } items-center mb-2`}
        >
          {dayjs(selectedDate).isSame(dayjs(), "day") && (
            <div className="flex space-x-6 items-center">
              {tabMapping.map((tab, index) => (
                <button
                  key={index}
                  className="font-medium shadow-md  focus:outline-none"
                  style={{
                    width: "149px",
                    height: "41px",
                    flexShrink: 0,
                    borderRadius: "37px",
                    background: activeTab === index + 1 ? "#50869A" : "#FFF",
                  }}
                  onClick={() => {
                    dispatch(setTab(index + 1));
                    // Clear searched user when tab is selected
                    clearSearchUser?.();
                    setSearchTerm("");
                    setShowSuggestions(false);
                    setSuggestions([]);
                    dob.current = "";
                  }}
                >
                  <div
                    className="flex w-full items-center justify-center"
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontStyle: "normal",
                      fontWeight: "400",
                      color: activeTab === index + 1 ? "white" : "black",
                    }}
                  >
                    {tab.label}
                    <div className="bg-[#e17954] text-white rounded-full w-5 h-5 text-center font-bold text-[9px] flex items-center justify-center ml-2">
                      {dbscount[tab.key] || 0}
                    </div>
                  </div>
                </button>
              ))}

              {activeTab ? (
                <CloseIcon
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(setTab(null));
                    // Clear searched user when tab is closed
                    clearSearchUser?.();
                    setSearchTerm("");
                    setShowSuggestions(false);
                    setSuggestions([]);
                    dob.current = "";
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          )}
          <div className="flex items-center space-x-4 ">
            <div className="flex items-center space-x-2 p-1 bg-white shadow-md rounded-lg">
              <BiList isCardView={isCardView} setIsCardView={setIsCardView} />
              <MaterialSymbols
                isCardView={isCardView}
                setIsCardView={setIsCardView}
              />
            </div>
       <div
  ref={calendarButtonRef}
  onClick={() => setIsCalendarOpen((prev) => !prev)}
  className="flex items-center justify-between gap-2 px-3 py-[10px] shadow-md bg-white rounded-[10px] cursor-pointer"
>
  {/* Left Arrow */}
  <div
    className="flex items-center cursor-pointer"
    onClick={(e) => {
      e.stopPropagation();            // ✅ prevent calendar open
      handlePrevDate();               // ✅ move to previous date
    }}
  >
    {leftarrow}
  </div>

  {/* Center Content (ONLY this should open calendar) */}
  <div className="flex items-center gap-3">
    <div className="flex flex-col leading-tight text-right">
      <div className="text-[12px] font-inter text-[#6B7280] font-normal">
        {isToday ? "Today" : selectedDate.format("dddd")}
      </div>
      <div className="text-[14px] font-inter font-bold text-[#111827]">
        {formatDateForUI(selectedDate)}
      </div>
    </div>

    <div className="flex items-center text-[#9CA3AF] text-xl">
      {actionDropDownCalenderIcon}
    </div>
  </div>

  {/* Right Arrow */}
  <div
    className="flex items-center cursor-pointer"
    onClick={(e) => {
      e.stopPropagation();            // ✅ prevent calendar open
      handleNextDate();               // ✅ move to next date
    }}
  >
    {rightarrow}
  </div>
</div>
            <button
              className="cursor-pointer"
              onClick={() => {
                setFiltermodal(true);
              }}
            >
              {filterIcon}
            </button>
            {/* <button
              type="button"
              onClick={() => setIsFlagOpen(true)}
              className="flex items-center focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none cursor-pointer"
              aria-label="Report an issue"
              title="Report an issue"
            >
              {flag}
            </button> */}
            {/* <FilterAltIcon onClick={handleFilterClick} className='cursor-pointer'/> */}
          </div>
        </div>
        <HomeToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={() => setOpenToast(false)}
        />
        {/* Calendar */}
        {isCalendarOpen && (
          <div
            ref={calendarRef}
                       className="absolute top-1/4 lg:top-28 right-16 z-10"
            style={{ maxWidth: "300px", width: "300px" }}
          >
            <DatePicker
              selected={currentDate ? dayjs(currentDate).toDate() : new Date()}
              onChange={(date) => handleDateChange(dayjs(date))}
              inline
              calendarClassName="custom-calendar nav-calendar"
              showMonthDropdown
              showYearDropdown
              yearDropdownItemNumber={15}
              dateFormat="MM/dd/yyyy"
            />
            <style>{`
              .nav-calendar.custom-calendar {
                background-color: white;
                border-radius: 10px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                padding: 16px;
                font-family: inherit;
                width: 100%;
              }
              .nav-calendar .react-datepicker__header {
                background-color: white;
                border-bottom: none;
                padding: 0 0 12px 0;
              }
              .nav-calendar .react-datepicker__current-month {
                font-size: 15px;
                font-weight: 500;
                color: #1D2951;
                margin-bottom: 0;
                padding-bottom: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 20px !important;
              }
              .nav-calendar .react-datepicker__current-month select {
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                background: white;
                border: none;
                font-size: 15px;
                font-weight: 500;
                color: #1D2951;
                cursor: pointer;
                padding-right: 28px;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right center;
                background-size: 10px 6px;
                outline: none;
              }
              .nav-calendar .react-datepicker__current-month select:focus,
              .nav-calendar .react-datepicker__current-month select:active,
              .nav-calendar .react-datepicker__current-month select:hover {
                outline: none;
                box-shadow: none;
                color: #1D2951;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
              }
              .nav-calendar .react-datepicker__month-dropdown,
              .nav-calendar .react-datepicker__year-dropdown {
                background-color: white;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                padding: 4px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                max-height: 200px;
                overflow-y: auto;
              }
              .nav-calendar .react-datepicker__year-dropdown {
                height: 260px;
                max-height: 260px;
              }
              .nav-calendar .react-datepicker__month-option,
              .nav-calendar .react-datepicker__year-option {
                padding: 6px 12px;
                cursor: pointer;
                font-size: 14px;
                border-radius: 4px;
                outline: none;
                color: #1D2951;
              }
              .nav-calendar .react-datepicker__month-option:focus,
              .nav-calendar .react-datepicker__year-option:focus {
                outline: none;
                box-shadow: none;
              }
              .nav-calendar .react-datepicker__month-option:hover,
              .nav-calendar .react-datepicker__year-option:hover {
                background-color: #f3f4f6;
              }
              .nav-calendar .react-datepicker__month-option--selected,
              .nav-calendar .react-datepicker__year-option--selected {
                background-color: #1D2951;
                color: white;
              }
              .nav-calendar .react-datepicker__day-names {
                display: flex;
                justify-content: space-around;
                margin-bottom: 8px;
                padding-top: 8px;
              }
              .nav-calendar .react-datepicker__day-name {
                width: 36px;
                line-height: 36px;
                margin: 0;
                color: #6b7280;
                font-size: 12px;
                font-weight: 500;
                text-align: center;
              }
              .nav-calendar .react-datepicker__month { margin: 0; padding: 0; }
              .nav-calendar .react-datepicker__week {
                display: flex;
                justify-content: space-around;
                margin-bottom: 4px;
              }
              .nav-calendar .react-datepicker__day {
                width: 34px;
                height: 34px;
                line-height: 36px;
                margin: 0;
                border-radius: 50%;
                color: #111827;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .nav-calendar .react-datepicker__day:hover {
                background-color: #f3f4f6;
                border-radius: 50%;
              }
              .nav-calendar .react-datepicker__day--selected,
              .nav-calendar .react-datepicker__day--keyboard-selected {
                background-color: #1D2951 !important;
                color: white !important;
                border-radius: 50%;
                font-weight: 500;
              }
              .nav-calendar .react-datepicker__day--selected:hover,
              .nav-calendar .react-datepicker__day--keyboard-selected:hover {
                background-color: #1D2951 !important;
              }
              .nav-calendar .react-datepicker__day--today {
                font-weight: 600;
                border: 1px solid #1D2951;
                border-radius: 50%;
                box-sizing: border-box;
              }
              .nav-calendar .react-datepicker__day--outside-month {
                color: #d1d5db;
              }
              .nav-calendar .react-datepicker__navigation {
                top: 16px;
                outline: none;
                width: 32px;
                height: 32px;
                border-radius: 4px;
              }
              .nav-calendar .react-datepicker__navigation:hover {
                background-color: #f3f4f6;
              }
              .nav-calendar .react-datepicker__navigation:focus {
                outline: none;
                box-shadow: none;
              }
              .nav-calendar .react-datepicker__navigation-icon::before {
                border-color: #111827;
                border-width: 2px 2px 0 0;
              }
            `}</style>
          </div>
        )}
      </div>
      <div className="mt-4 px-14">
        {chips.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            {chips.map((c, i) => (
              <span
                key={`${c.group}-${c.key}-${i}`}
                className="inline-flex items-center gap-1 rounded-xl border-[2px] border-[#818CF8] bg-[#EEF2FF] px-2 py-1 text-[12px] font-inter font-medium text-[#7E7E7E]"
              >
                {c.text}
                <button
                  onClick={() => handleRemoveChip(c)}
                  className="ml-1 p-[2px]"
                  aria-label="Remove filter"
                  title="Remove"
                >
                  <CloseIcon
                    sx={{ fontSize: 16, fontWeight: "bold" }}
                    color="inherit"
                  />
                </button>
              </span>
            ))}

            <button
              onClick={handleClearAll}
              className="text-[12px] text-[#000000] font-light font-inter  hover:opacity-80"
            >
              Clear all
            </button>
          </div>
        )}
      </div>

      {/* <FlagModal
        open={isFlagOpen}
        defaultText=""
        defaultStatus="unresolved"
        onClose={() => setIsFlagOpen(false)}
        onUpdate={({ text, status }) => {
          // Handle flag update logic here
          console.log("Flag updated:", { text, status });
          setIsFlagOpen(false);
        }}
      /> */}
    </div>
  );
};

export default NavigationMenu;
